angular.module('impactx.companyhierarchy').controller('NestedTreeListCtrl', [NestedTreeListController]);

function NestedTreeListController() {
    var self = this;

    self.expandSub = function (event, entry) {
        if (entry.isLeaf) {
            event.stopPropagation();
            event.preventDefault();
        }
        else {
            self.expand({event: event, entry: entry});
        }
    };

    self.editEntryInternal = function (event, entry) {
        self.editEntry({event: event, entry: entry});
    };

    self.getIconClass = function (entry) {
        var result = '';
        if (entry.isFolder) {
            result = 'mdi-folder ';
        }

        switch (entry.type) {
            case "COMPANY":
                result += 'mdi-home-city mdi-icon-blue';
                break;
            case "USER":
                result += 'mdi-account mdi-icon-red';
                break;
            case "CONTRACT":
                result += 'mdi-gavel mdi-icon-dark-grey';
                break;
            case "CATALOG":
                result += 'mdi-book mdi-icon-green';
                break;
            case "CTT":
                result += 'mdi-numeric-1-box-outline mdi-icon-grey';
                break;
            case "CTU":
                result += 'mdi-numeric-2-box-outline mdi-icon-grey';
                break;
            case "PRJ":
                result += 'mdi-numeric-3-box-outline mdi-icon-grey';
                break;
            case "CTRLA":
                result += 'mdi-numeric-4-box-outline mdi-icon-grey';
                break;
            case "CTRLB":
                result += 'mdi-numeric-5-box-outline mdi-icon-grey';
                break;
            default:
                return "";
        }


        return result;
    }
}